module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$hydrowareSecurityJS.canDisplay_A('managevenue') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Manage Venue"
    }
  })], 1) : _c('div', {
    staticClass: "venuesForm"
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "x_panel tile "
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v(" Manage Venue ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.$hydrowareSecurityJS.canAdd_A('managevenue')) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addPools('addPool')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "10px",
      "color": "white"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Add Venue")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.togglePoolList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "10px",
      "color": "white"
    }
  }), _vm._v(" "), (_vm.isShowallpools) ? _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Include Archived Venues")]) : _vm._e(), _vm._v(" "), (!_vm.isShowallpools) ? _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Exclude Archived Venues")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "vue-tables-options"
    }
  }, [_c('v-client-table', {
    ref: "dragtable",
    attrs: {
      "data": _vm.poolList,
      "columns": _vm.pools_columns,
      "options": _vm.optionstable
    },
    scopedSlots: _vm._u([{
      key: "PoolName",
      fn: function(props) {
        return [_vm._v("\r\n                      " + _vm._s(props.row.PoolName) + "\r\n                      "), (!props.row.PoolIsActive) ? _c('div', {
          staticClass: "pull-right"
        }, [_c('span', {
          staticClass: "label label-sm label-warning",
          staticStyle: {
            "background-color": "rgba(99, 61, 50, 0.78)"
          }
        }, [_c('i', {
          staticClass: "fa fa-archive"
        })]), _vm._v(" "), _c('span', {
          staticClass: "label label-sm label-warning",
          staticStyle: {
            "background-color": "rgba(165, 68, 42, 0.78)"
          }
        }, [_vm._v(" \r\n                          Archived \r\n                        ")])]) : _vm._e()]
      }
    }, {
      key: "Actions",
      fn: function(props) {
        return [_c('div', [_c('hydroware-viewOrEdit-button', {
          attrs: {
            "EV": _vm.$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('managevenue')
          },
          on: {
            "click": function($event) {
              return _vm.EditPool(props)
            }
          }
        }), _vm._v(" "), _c('span', [(_vm.$hydrowareSecurityJS.canDelete_A('managevenue')) ? _c('hydroware-delete-button', {
          on: {
            "click": function($event) {
              return _vm.DeletePool(props)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), (_vm.$hydrowareSecurityJS.canEdit_A('managevenue')) ? _c('el-button', {
          staticClass: "fa fa-archive",
          staticStyle: {
            "color": "white!important",
            "background-color": "#a5442ac7!important",
            "border-color": "#a5442ac7!important"
          },
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.ChangeStatus(props)
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "Addpoolmodel",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg ",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [(!_vm.isediting) ? _c('div', [_c('h3', [_vm._v("Add Venue " + _vm._s(_vm.addPool.PoolLocationName))])]) : _vm._e(), _vm._v(" "), (_vm.isediting && _vm.$hydrowareSecurityJS.canEdit_A('managevenue')) ? _c('div', [_c('h3', [_vm._v("Edit Venue")])]) : _vm._e(), _vm._v(" "), (_vm.isediting && !_vm.$hydrowareSecurityJS.canEdit_A('managevenue')) ? _c('div', [_c('h3', [_vm._v("Venue")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('el-form', {
    ref: "addPool",
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "disabled": _vm.$hydrowareSecurityJS.disableDataEntry_A('managevenue', _vm.isAddingOrEditing),
      "model": "addPool",
      "spellcheck": "false",
      "rules": _vm.rules
    }
  }, [_c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "Facility"
    }
  }, [(!_vm.isnewLocation) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-md-10 col-lg-10"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Facility",
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "size": "large"
    },
    model: {
      value: (_vm.poollocationId),
      callback: function($$v) {
        _vm.poollocationId = $$v
      },
      expression: "poollocationId"
    }
  }, _vm._l((_vm.locationList), function(item) {
    return _c('el-option', {
      key: item.LocationId,
      attrs: {
        "label": item.LocationName,
        "value": item.LocationId
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isnewLocation) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.addCurrentLocation
    }
  }, [_vm._v(" Back")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Facility Name",
      "prop": "PoolLocationName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Facility Name",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolLocationName),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolLocationName", $$v)
      },
      expression: "addPool.PoolLocationName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "",
      "rows": 3,
      "maxlength": 400
    },
    model: {
      value: (_vm.addPool.PoolLocationAddress),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolLocationAddress", $$v)
      },
      expression: "addPool.PoolLocationAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone Number"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addPool.PoolLocationPhoneNumber),
      expression: "addPool.PoolLocationPhoneNumber"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "eltextcopy placeholder-class",
    attrs: {
      "type": "text",
      "placeholder": "Enter Phone Number"
    },
    domProps: {
      "value": (_vm.addPool.PoolLocationPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addPool, "PoolLocationPhoneNumber", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax Number"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addPool.PoolLocationFaxNumber),
      expression: "addPool.PoolLocationFaxNumber"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "eltextcopy placeholder-class",
    attrs: {
      "type": "text",
      "placeholder": "Enter Fax Number"
    },
    domProps: {
      "value": (_vm.addPool.PoolLocationFaxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addPool, "PoolLocationFaxNumber", $event.target.value)
      }
    }
  })])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Venue Profile"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Type:",
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.pooltypeId),
      callback: function($$v) {
        _vm.pooltypeId = $$v
      },
      expression: "pooltypeId"
    }
  }, _vm._l((_vm.poolTypes), function(item) {
    return _c('el-option', {
      key: item.PoolPoolTypeId,
      attrs: {
        "label": item.PoolTypeDescription,
        "value": item.PoolPoolTypeId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Open Time:",
      "prop": "PoolOpening"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "Pick a Time"
    },
    model: {
      value: (_vm.addPool.PoolOpening),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolOpening", $$v)
      },
      expression: "addPool.PoolOpening"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Close Time:",
      "prop": "PoolClosing"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "Pick a Time"
    },
    model: {
      value: (_vm.addPool.PoolClosing),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolClosing", $$v)
      },
      expression: "addPool.PoolClosing"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name:",
      "prop": "PoolName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Pool Name",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolName),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolName", $$v)
      },
      expression: "addPool.PoolName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Located:",
      "prop": "PoolLocated"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "Indoor"
    },
    model: {
      value: (_vm.addPool.PoolLocated),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolLocated", $$v)
      },
      expression: "addPool.PoolLocated"
    }
  }, [_vm._v("Indoor")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "Outdoor"
    },
    model: {
      value: (_vm.addPool.PoolLocated),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolLocated", $$v)
      },
      expression: "addPool.PoolLocated"
    }
  }, [_vm._v("Outdoor")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Shape:",
      "prop": "PoolShape"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "-Please Select Shape-"
    },
    model: {
      value: (_vm.addPool.PoolShape),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolShape", $$v)
      },
      expression: "addPool.PoolShape"
    }
  }, _vm._l((_vm.ShapeList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Shape,
        "value": item.Shape
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Lanes",
      "prop": "PoolLanes"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Lanes",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolLanes),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolLanes", $$v)
      },
      expression: "addPool.PoolLanes"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Stations",
      "prop": "PoolStations"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Stations",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolStations),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolStations", $$v)
      },
      expression: "addPool.PoolStations"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Length",
      "prop": "PoolLength"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter length",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolLength),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolLength", $$v)
      },
      expression: "addPool.PoolLength"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Width",
      "prop": "PoolWidth"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter width",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolWidth),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolWidth", $$v)
      },
      expression: "addPool.PoolWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "UoM:",
      "prop": "PoolLengthWidthUoM"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Unit of measurement"
    },
    model: {
      value: (_vm.addPool.PoolLengthWidthUoM),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolLengthWidthUoM", $$v)
      },
      expression: "addPool.PoolLengthWidthUoM"
    }
  }, _vm._l((_vm.UomList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Uom,
        "value": item.Uom
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Description:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Describe the Pool",
      "rows": 3,
      "maxlength": 400
    },
    model: {
      value: (_vm.addPool.PoolDescription),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolDescription", $$v)
      },
      expression: "addPool.PoolDescription"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Other"
    },
    on: {
      "tab-click": function($event) {
        return _vm.ValidatePoolDetails('addPool')
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Shallow Max Bathers:",
      "prop": "PoolShalowMaxBathers"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter shallow bather",
      "maxlength": 30,
      "size": ""
    },
    model: {
      value: (_vm.addPool.PoolShalowMaxBathers),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolShalowMaxBathers", $$v)
      },
      expression: "addPool.PoolShalowMaxBathers"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Deep Max Bathers:",
      "prop": "PoolDeepMaxBathers"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter deep bather",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolDeepMaxBathers),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolDeepMaxBathers", $$v)
      },
      expression: "addPool.PoolDeepMaxBathers"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total Max Bathers:",
      "prop": "PoolTotalMaxBathers"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter max bathers",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolTotalMaxBathers),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolTotalMaxBathers", $$v)
      },
      expression: "addPool.PoolTotalMaxBathers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Volume:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Volume",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolVolume),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolVolume", $$v)
      },
      expression: "addPool.PoolVolume"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "UoM:",
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Unit of measurement"
    },
    model: {
      value: (_vm.addPool.PoolVolumeUoM),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolVolumeUoM", $$v)
      },
      expression: "addPool.PoolVolumeUoM"
    }
  }, _vm._l((_vm.VolumeUomList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Uom,
        "value": item.Uom
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Water Area:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Water Area",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolArea),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolArea", $$v)
      },
      expression: "addPool.PoolArea"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "UoM (Squared):",
      "prop": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("UoM"), _c('span', {
    staticStyle: {
      "vertical-align": "super",
      "font-size": "smaller"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Unit of measurement"
    },
    model: {
      value: (_vm.addPool.PoolAreaUoM),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolAreaUoM", $$v)
      },
      expression: "addPool.PoolAreaUoM"
    }
  }, _vm._l((_vm.UomList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Uom,
        "value": item.Uom
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Min Depth:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter mininmum depth",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolMinDepth),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolMinDepth", $$v)
      },
      expression: "addPool.PoolMinDepth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "UoM:",
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Unit of measurement"
    },
    model: {
      value: (_vm.addPool.PoolMinDepthUoM),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolMinDepthUoM", $$v)
      },
      expression: "addPool.PoolMinDepthUoM"
    }
  }, _vm._l((_vm.UomList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Uom,
        "value": item.Uom
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Max Depth:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter maximum depth",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolMaxDepth),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolMaxDepth", $$v)
      },
      expression: "addPool.PoolMaxDepth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "UoM:",
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Unit of measurement"
    },
    model: {
      value: (_vm.addPool.PoolMaxDepthUoM),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolMaxDepthUoM", $$v)
      },
      expression: "addPool.PoolMaxDepthUoM"
    }
  }, _vm._l((_vm.UomList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Uom,
        "value": item.Uom
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Turnover Rate Ideal:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter IDEAL turn over rate",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolTurnOverTime),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolTurnOverTime", $$v)
      },
      expression: "addPool.PoolTurnOverTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Turnover Rate Min:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter MIN turn over rate",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolTurnOverTime_Min),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolTurnOverTime_Min", $$v)
      },
      expression: "addPool.PoolTurnOverTime_Min"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Turnover Rate Max:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter MAX turn over rate",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolTurnOverTime_Max),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolTurnOverTime_Max", $$v)
      },
      expression: "addPool.PoolTurnOverTime_Max"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "UoM:",
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Unit of measurement"
    },
    model: {
      value: (_vm.addPool.PoolTurnOverTime_UoM),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolTurnOverTime_UoM", $$v)
      },
      expression: "addPool.PoolTurnOverTime_UoM"
    }
  }, _vm._l((_vm.TimeUoM), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Uom,
        "value": item.Uom
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Influent Pressure Ideal:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter IDEAL influent pressure",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolInfluentPressure),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolInfluentPressure", $$v)
      },
      expression: "addPool.PoolInfluentPressure"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Influent Pressure Min:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter MIN influent pressure",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolInfluentPressure_Min),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolInfluentPressure_Min", $$v)
      },
      expression: "addPool.PoolInfluentPressure_Min"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Influent Pressure Max:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter MAX influent pressure",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolInfluentPressure_Max),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolInfluentPressure_Max", $$v)
      },
      expression: "addPool.PoolInfluentPressure_Max"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Influent Pressure UoM:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Enter influent pressure UoM",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolInfluentPressureUoM),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolInfluentPressureUoM", $$v)
      },
      expression: "addPool.PoolInfluentPressureUoM"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Efluent Pressure Ideal:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter IDEAL efluent pressure",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolEfluentPressure),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolEfluentPressure", $$v)
      },
      expression: "addPool.PoolEfluentPressure"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Efluent Pressure Min:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter MIN efluent pressure",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolEfluentPressure_Min),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolEfluentPressure_Min", $$v)
      },
      expression: "addPool.PoolEfluentPressure_Min"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Efluent Pressure Max:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter MAX efluent pressure",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolEfluentPressure_Max),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolEfluentPressure_Max", $$v)
      },
      expression: "addPool.PoolEfluentPressure_Max"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Efluent Pressure UoM:",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Enter efluent pressure UoM",
      "maxlength": 30
    },
    model: {
      value: (_vm.addPool.PoolEfluentPressureUoM),
      callback: function($$v) {
        _vm.$set(_vm.addPool, "PoolEfluentPressureUoM", $$v)
      },
      expression: "addPool.PoolEfluentPressureUoM"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-6 col-xs-6 col-sm-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-6 col-xs-6 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "color": "gray",
      "width": "125px",
      "float": "right"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.CancelAddPool()
      }
    }
  }, [_vm._v("\r\n                Cancel\r\n              ")]), _vm._v(" "), (_vm.isediting) ? _c('div', [(_vm.$hydrowareSecurityJS.canEdit_A("managevenue")) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UpdatePool('addPool')
      }
    }
  }, [_vm._v("\r\n                      Update\r\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isediting) ? _c('div', [_c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.CreatePool('addPool')
      }
    }
  }, [_vm._v("Create\r\n              ")])]) : _vm._e()])])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7ecafc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Administration/ManagePools/ManagePools.vue
// module id = 843
// module chunks = 1